export default __webpack_public_path__ + "static/media/ShareEmotions.9be0a2e7.png";